export const DATA_NAME = 'data'

export const WIDTH = 'width'
export const RATIO = 'ratio'
export const DIAMETER = 'diameter'

export const FIRST = WIDTH
